<script setup lang="ts">
import { ref, watch, type Ref } from 'vue'
import type { GwrData } from './liegenschaft/form-fields.vue'

const modelValue = defineModel<boolean>()

const { changes } = defineProps<{
    changes: GwrData[]
}>()

const toggle: Ref<Record<string, number>> = ref({})

watch(
    () => changes,
    (ch) => {
        ch.forEach((c) => (toggle.value[c.key] = c.gwrValue ? 1 : 0))
    },
)

const emit = defineEmits<{
    (e: 'apply', changes: GwrData[]): void
}>()

function applyGwrData() {
    const result: GwrData[] = []
    changes.forEach((c) => {
        result.push({ key: c.key, value: toggle.value[c.key] === 0 ? c.value : c.gwrValue })
    })
    emit('apply', result)
}
</script>

<template>
    <v-dialog v-model:model-value="modelValue" max-width="700">
        <v-card>
            <v-card-title class="headline">{{ $t('choose_correct_value') }}</v-card-title>
            <v-card-text>
                <v-alert type="warning" class="mb-4">
                    {{ $t('check_gwr_data') }}
                </v-alert>
                <v-row wrap>
                    <v-col cols="12" md="4" class="text-subtitle-1 text-medium-emphasis">
                        {{ $t('field') }}
                    </v-col>
                    <v-col
                        cols="12"
                        md="8"
                        class="text-subtitle-1 text-medium-emphasis"
                        style="text-align: center"
                    >
                        {{ $t('actual_value') }} / {{ $t('gwr_value') }}
                    </v-col>
                </v-row>
                <v-row v-for="change in changes" :key="change.key" :value="change.value" wrap style="align-items: center">
                    <v-col cols="12" md="4" dense >
                        {{ $t(change.key) }}
                    </v-col>
                    <v-col cols="12" md="8" dense>
                        <v-btn-toggle
                            v-model="toggle[change.key]"
                            class="gwrdata-toggle"
                            dense
                            mandatory
                            color="success"
                        >
                            <v-btn width="200">{{ change.value || '-' }}</v-btn>
                            <v-btn width="200">{{ change.gwrValue || '-' }}</v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn text color="decline" @click="$emit('update:modelValue', false)">
                    {{ $t('cancel') }}
                </v-btn>
                <v-btn color="action" @click="applyGwrData">
                    {{ $t('ok') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
@media screen and (max-width: 500px) {
    .gwrdata-toggle {
        flex-direction: column;
    }
}
.gwrdata-toggle {

    border: 1px solid rgb(200, 200, 200)
}
</style>

<style scoped>
.v-card__text,
.v-card__title {
    word-break: normal !important;
}
</style>
